import { generatePath } from "react-router";
import apiClient from "services/ApiClient";
import { API_ROUTES } from "definitions/constants/routeConstants";
import type {
  CreateOverridePayload,
  TaskNotificationChannelOverride,
  UpdateOverridePayload,
} from "./types";

export async function fetchOverrides(): Promise<TaskNotificationChannelOverride[]> {
  return apiClient.get<TaskNotificationChannelOverride[]>(API_ROUTES.taskNotificationChannelOverrides.base);
}

export async function createOverride(payload: CreateOverridePayload): Promise<TaskNotificationChannelOverride> {
  return apiClient.post<TaskNotificationChannelOverride>(API_ROUTES.taskNotificationChannelOverrides.base, {
    taskNotificationChannelOverride: payload,
  });
}

export async function updateOverride(
  id: number,
  payload: UpdateOverridePayload,
): Promise<TaskNotificationChannelOverride> {
  return apiClient.put<TaskNotificationChannelOverride>(
    generatePath(API_ROUTES.taskNotificationChannelOverrides.show, { id: String(id) }),
    { taskNotificationChannelOverride: payload },
  );
}

export async function deleteOverride(id: number): Promise<void> {
  await apiClient.delete(
    generatePath(API_ROUTES.taskNotificationChannelOverrides.show, { id: String(id) }),
  );
}
